import React from 'react';
import './style.css';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import LogoV2 from '../../assets/images/logo_v2.svg';
import api from '../../api';

// React.useEffect(() => {
//     const url = window.location.href.split('/');
//     if (url.includes('niji-qa')) {
//       localStorage.setItem('qa-mode', 'on');
//     }
//   }, []);
const HeaderSection=({executeScroll ,homeSection : any = null, pages})=>{
    
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [launchLoading, setLaunchLoading] = React.useState(false);

    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };

    const handleTestLaunch = () => {
      setLaunchLoading(true);
      api.launch.generateTestUrl()
        .then((res) => {
          const launchUrl = res?.data?.launchUrl;
          if (launchUrl) {
            window.open(launchUrl, '_blank');
          }
          setLaunchLoading(false);
        })
        .catch(() => {
          setLaunchLoading(false);
          alert('Failed to generate test launch URL. Please ensure the backend is running.');
        });
    };
    

    return      <div>
                <AppBar className="header-style">
                  <Container maxWidth="xl" className='header-pad'>
                    <Toolbar disableGutters className="header-hight"sx={{ display : "flex" , justifyContent :"flex-end" }}>
                      <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
                      >
                        <a href={process.env.REACT_APP_APPLICATION_URL}>
                          <img src={LogoV2} alt="Niji in bloom" title="Niji in bloom"/>
                        </a>
                      </Typography>

                      <Box sx={{ flexGrow: 3, display: { xs: 'flex', md: 'none' }, justifyContent :"flex-end" }}>
                        <IconButton
                          size="large"
                          aria-label="account of current user"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={handleOpenNavMenu}
                          color="inherit"
                          
                        >
                          <MenuIcon />
                        </IconButton>
                        <Menu
                          id="menu-appbar"
                          anchorEl={anchorElNav}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                          }}
                          keepMounted
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                          open={Boolean(anchorElNav)}
                          onClose={handleCloseNavMenu}
                          sx={{
                            display: { xs: 'block', md: 'none' },
                          }}
                        >
                          <MenuItem key="Home" onClick={()=> {handleCloseNavMenu();executeScroll("home"); }}>
                              <Typography textAlign="center">Home </Typography>
                            </MenuItem>
                          {pages.map((page) => (
                            <MenuItem key={page} onClick={handleCloseNavMenu}>
                              <Typography textAlign="center">{page} </Typography>
                            </MenuItem>
                          ))}
                        </Menu>
                      </Box>
                      
                      <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent :"flex-end"}}>
                        {pages.map((page) => (
                          <Button
                          className='header-padding'
                            key={page}
                            onClick={() => { handleCloseNavMenu();executeScroll(page)}}
                            sx={{ my: 2, color: 'white', display: 'block' }}
                          >
                            {page} 
                          </Button>
                        ))}
                        {/* Member Login hidden for participant flow */}
                        {/* <Link className='loginButton' to="/login">
                          Member Login
                        </Link> */}
                        <span
                          className='loginButton'
                          onClick={handleTestLaunch}
                          style={{ cursor: launchLoading ? 'wait' : 'pointer' }}
                        >
                          {launchLoading ? 'Loading...' : 'Test Launch'}
                        </span>
                      </Box>

                      
                    </Toolbar>
                  </Container>
                </AppBar>
                </div>
}
export default HeaderSection;